{
  "Accessibility menu": "תפריט נגישות",
  "Close": "סגור",
  "Content adjustments": "התאמות תוכן",
  "Navigation adjustments": "התאמות ניווט",
  "Align Left": "יישור לשמאל",
  "Adjust Font Size": "התאם גודל פונט",
  "Highlight Title": "הדגש כותרת",
  "Highlight Links": "הדגש קישורים",
  "Readable Font": "פונט קריא",
  "Colour adjustments": "התאמות צבע",
  "Dark Contrast": "ניגודיות כהה",
  "Light Contrast": "ניגודיות בהירה",
  "High Contrast": "ניגודיות גבוהה",
  "High Saturation": "רווי צבע גבוה",
  "Low Saturation": "רווי צבע נמוך",
  "Monochrome": "מונוכרום",
  "Tools": "כלים",
  "Reading Guide": "מדריך קריאה",
  "Big Cursor": "סמן גדול",
  "Increase Font Size": "הגדל גודל פונט",
  "Decrease Font Size": "הקטן גודל פונט",
  "Letter Spacing": "מרווח בין אותיות",
  "Line Height": "גובה שורה",
  "Font Weight": "משקל הפונט",
  "Dyslexia Font": "פונט לדיסלקטים",
  "Language": "שפה",
  "Accessibility widget": "פתח תפריט נגישות",
  "Accessibility Profiles": "פרופילי נגישות",
  "Cognitive Disability": "מוגבלות קוגניטיבית",
  "Seizure Safe": "בטוח לאפילפסיה",
  "Accessibility statement": "הצהרת נגישות",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "עצירת אנימציות",
  "Reset all settings": "איפוס הגדרות",
  "Shortcut:": "Shortcut:"
}
